import {
  DocFlowSendingCommunicationTable,
  DocFlowSendingEmailContent,
  DocFlowSendingEpostContent,
  DocFlowSendingResultTable,
  DocFlowSendingWidgetType,
} from '../../DocFlowSending'

export function getSendingWidgetContent(activeWidget) {
  switch (activeWidget) {
    case DocFlowSendingWidgetType.CommunicationSettings:
      return <DocFlowSendingCommunicationTable />

    case DocFlowSendingWidgetType.EpostSettings:
      return <DocFlowSendingEpostContent />

    case DocFlowSendingWidgetType.EmailSettings:
      return <DocFlowSendingEmailContent />

    case DocFlowSendingWidgetType.Result:
      return <DocFlowSendingResultTable />

    default:
      return null
  }
}
